module.exports = __webpack_public_path__ + "files/537802c9017d0a116bba46ec362484f3.svg";